import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, bevel, plate, rib, mergeBones, damp, boneG } from './kit';
/* ============================================================
   SCHLANGE 蛇 —— BOSS・節肢
   ============================================================

   剪影：13 節、22 單位長
   二階段：節段分離浮空・各自射擊（紅→橙）

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-07 SCHLANGE 蛇 ── 13 節、22 單位長，唯一「不是一個量體」的 BOSS。
   P1 貼地波動，靠接觸傷人（紅）→ 看波峰走。
   P2 節段整個分離浮空，每節自己射（橙・直射）→ 從一條線變成一片彈幕。
   這隻的存在是為了測試「剪影家族」這套系統的邊界：牠不屬於任何家族。 */
var SEGN = 13;
export function buildSchlange(){
  var GL = glowMat(TINT.red.hex, 2.0), GLA = glowMat(TINT.amb.hex, 2.2);
  var root = new THREE.Group(), i;
  var segs = [];
  for (i = 0; i < SEGN; i++){
    var k = 1 - i*0.045;
    var sg = boneG(root, 0, 0.9, -i*1.55);
    if (i === 0){
      sg.add(bevel(M.dark,  1.50, 1.20, 2.00, [0,0,0]));
      sg.add(plate(M.armor, 1.66, 0.60, 1.10, [0, 0.40, 0.50], -0.40));
      sg.add(plate(M.armor, 1.40, 0.90, 0.50, [0,-0.10, 1.00], -0.90));
      sg.add(mesh(G.cone, M.armor, [0.70,1.40,0.70], [ 0.42, 0.62, 0.30], [-0.5,0,0.3]));
      sg.add(mesh(G.cone, M.armor, [0.70,1.40,0.70], [-0.42, 0.62, 0.30], [-0.5,0,-0.3]));
      var ey = mesh(G.box, GL, [1.10,0.16,0.14], [0, 0.28, 0.96], [-0.30,0,0]);
      ey.userData.noMerge = 1; sg.add(ey); sg.userData.eye = ey;
    } else {
      sg.add(bevel(M.dark,  1.30*k, 1.05*k, 1.45, [0,0,0]));
      sg.add(plate(M.armor, 1.44*k, 0.46*k, 0.80, [0, 0.34*k, 0.20], -0.30));
      sg.add(rib  (M.armor, 0.12, 0.90*k, 0.12, [ 0.62*k, 0, 0]));
      sg.add(rib  (M.armor, 0.12, 0.90*k, 0.12, [-0.62*k, 0, 0]));
      sg.add(mesh(G.cone, M.trim, [0.34,0.90,0.34], [0, 0.80*k, -0.20], [-0.34,0,0]));
      var rg = mesh(G.tor, GLA, [1.30*k,1.30*k,0.34], [0,0,-0.10], [HP,0,0]);
      rg.userData.noMerge = 1; rg.visible = false; sg.add(rg); sg.userData.ring = rg;
      var gl = mesh(G.box, GL, [0.10,0.10,1.00], [ 0.66*k, 0, 0]);
      gl.userData.noMerge = 1; sg.add(gl); sg.userData.side = gl;
    }
    segs.push(sg);
  }
  root.userData.rig = {segs:segs, GL:GL, GLA:GLA};
  return mergeBones(root);
}
export function updSchlange(rig, o, dt){
  rig.sp = damp(rig.sp === undefined ? 0 : rig.sp, o.p2 ? 1 : 0, 1.6, dt);
  var f = rig.sp, i, sg;
  for (i = 0; i < SEGN; i++){
    sg = rig.segs[i];
    var t = o.t*1.5 - i*0.42;
    var gap = 1.55 * (1 + 0.55*f);
    sg.position.z = -i*gap;
    sg.position.x = Math.sin(t)*1.30*(1 - 0.4*f);
    sg.position.y = 0.90 + Math.sin(t*1.3)*0.42*(1-f)
                  + f*(1.60 + 0.16*i + 0.30*Math.sin(o.t*1.1 + i));
    sg.rotation.y = Math.cos(t)*0.42*(1 - 0.5*f);
    sg.rotation.z = Math.sin(t*1.3)*0.20;
    sg.rotation.x = (i === 0) ? (-0.20 + o.tel*0.34 - o.atk*0.50)*(1-f) : 0;
    if (sg.userData.ring){ sg.userData.ring.visible = f > 0.4; }
    if (sg.userData.side)  sg.userData.side.visible = f < 0.6;
  }
  rig.GL.emissiveIntensity  = 2.0 + 3.0*o.tel + 6*o.atk*(1-o.atk);
  rig.GLA.emissiveIntensity = 1.2 + 2.6*f + 5*o.atk*f;
}